import { render, staticRenderFns } from "./pricing-table.vue?vue&type=template&id=2339cdc7"
import script from "./pricing-table.vue?vue&type=script&lang=js"
export * from "./pricing-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports